import * as React from 'react';
import enumerate from 'lib/enumerate';
import MailTo from 'components/MailTo';
import LinkConstants from 'constants/LinkConstants';
import Link from 'components/Link';

export const ErrorTypes = enumerate([
  'EXPIRED_TOKEN',
  'UNKNOWN_TOKEN',
  'FORM_ERROR',
  'SERVER_ERROR',
]);

export const ErrorMessages = {
  [ErrorTypes.EXPIRED_TOKEN]: {
    DEFAULT: {
      title: <span>This link has expired.</span>,
      body: <span>{'Sorry! Try using a link from a more recent email.'}</span>,
    },

    REPORT_CHAT: {
      title: <span>Oops, the link to report this Chat has expired.</span>,
      body: (
        <span>
          {'Please use the report link on a Chat received less than 24 hours ago or email '}
          <MailTo to={LinkConstants.REPORT_EMAIL} />.
        </span>
      ),
    },

    EMAIL_UNSUBSCRIBE: {
      title: <span>This link has expired.</span>,
      body: (
        <span>
          {'Sorry! Try unsubscribing from a more recent email, or '}
          <Link to="/log_in?locationOnAuth=/settings/notifications">log in</Link>
          {' to change your notification settings.'}
        </span>
      ),
    },
  },

  [ErrorTypes.UNKNOWN_TOKEN]: {
    DEFAULT: {
      title: <span>Oops, something went wrong!</span>,
      body: <span>{'We don’t recognize this link.'}</span>,
    },
    REPORT_CHAT: {
      title: <span>Oops, something went wrong!</span>,
      body: (
        <span>
          {'We don’t recognize this link, please email '}
          <MailTo to={LinkConstants.REPORT_EMAIL} />
          {' if you’d like to report a Chat.'}
        </span>
      ),
    },
  },
};
